import React from "react";
import { Stack, HStack, Skeleton, SkeletonCircle, StackDivider, Divider } from "@chakra-ui/react";

/**
 * TransactionSummarySkeletons
 * @returns JSX.Element
 * @description
 * Full page skeletons for the transaction summary view to show while
 * loading both the invoice information and payment methods.
 */
export default function TransactionSummarySkeletons() {
  return (
    <Stack spacing={6} pb={4} data-testid="skeletons">
      <Stack>
        <Skeleton height="24px" width="50%" />
        <Skeleton height="20px" width="40%" />
      </Stack>
      <Stack divider={<StackDivider />} spacing={4}>
        <HStack align="flex-start" justify="space-between">
          <Stack flex={1}>
            <Skeleton height="14px" width="40%" />
            <Skeleton height="14px" width="25%" />
          </Stack>
          <Skeleton height="14px" width="20%" />
        </HStack>
        <HStack align="flex-start" justify="space-between">
          <Stack flex={1}>
            <Skeleton height="14px" width="40%" />
            <Skeleton height="14px" width="25%" />
          </Stack>
          <Skeleton height="14px" width="20%" />
        </HStack>
        <HStack align="flex-start" justify="space-between">
          <Skeleton height="24px" width="25%" />
          <Skeleton height="24px" width="25%" />
        </HStack>
      </Stack>
      <Divider />

      <Skeleton height="28px" width="70%" />
      <Stack divider={<StackDivider />} spacing={4}>
        <HStack justify="space-between">
          <HStack flex={1}>
            <SkeletonCircle size={6} mr={2} />
            <Skeleton height="24px" width="32px" />
          </HStack>
          <Skeleton height="24px" width="35%" />
        </HStack>
        <HStack justify="space-between">
          <HStack flex={1}>
            <SkeletonCircle size={6} mr={2} />
            <Skeleton height="24px" width="32px" />
          </HStack>
          <Skeleton height="24px" width="35%" />
        </HStack>
      </Stack>

      <Stack pt={4}>
        <Skeleton height="40px" width="100%" />
        <Skeleton height="14px" width="40%" />
      </Stack>
    </Stack>
  );
}
